export const PATH_HYDRATION = '/hydration';
export const PATH_HYDRATION_HISTORY = '/hydration/history';
